export default __webpack_public_path__ + "static/media/how_to_3.e31568ae.png";